import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { iframeResizer as iframeResizerLib } from 'iframe-resizer';
import ReactResizeDetector from 'react-resize-detector';
import { debounce } from 'underscore';
import { servicios } from '../properties';

class AltaReembolsos extends Component {
    iframeResizer = [];

    componentWillUnmount() {
        if (this.iframeResizer.length && this.iframeResizer[0].iFrameResizer) {
            this.iframeResizer[0].iFrameResizer.close();
        }
    }

    resizeIframe = () => {
        const { iFrame } = this.refs;
        let minHeight = Math.round(window.innerHeight / 2);
        minHeight = (minHeight <= 360) ? 360 : minHeight;
        if (!iFrame) return;
        this.iframeResizer = iframeResizerLib({
            log: false,
            heightCalculationMethod: 'taggedElement',
            autoResize: true,
            minHeight: minHeight
        }, iFrame);
    }

    getUrlGmm = () => {
        const portalAseguradoGMM = servicios.siniestrosReembolsos.portalAseguradoGMM;
        return portalAseguradoGMM.slice(0, portalAseguradoGMM.lastIndexOf('/'));
    }

    getSizeHeader = () => {
        const menuMobile = document.querySelectorAll('.show-mobile');
        const menuWeb = document.querySelectorAll('.hide-mobile');
        let sizeHeader = 0;

        if (menuMobile) {
            menuMobile.forEach(e => sizeHeader += e.offsetHeight); 
        }

        if (menuWeb) {
            menuWeb.forEach(e => sizeHeader += e.offsetHeight); 
        }

        return sizeHeader;
    }

    onToScroll = (postMessage) => {
        const sizeIframe = document.querySelector('#web').offsetHeight;

        if (String(postMessage).startsWith('toMiddleScroll')) {
            const toMiddle = this.getSizeHeader() + (sizeIframe < 800 ? 0 : (sizeIframe / 3));
            console.log('🚀 ~ scroll middle', toMiddle)
            window.scrollTo(0, toMiddle);
        }

        if (String(postMessage).startsWith('toBottomScroll')) {
            const positionBottom = sizeIframe - this.getSizeHeader();
            const toBootom = positionBottom > 200 ? positionBottom - 100 : positionBottom;
            console.log('🚀 ~ scroll bottom', toBootom)
            window.scrollTo(0, toBootom);
        }

        if (String(postMessage).startsWith('toTopScroll')) {
            const toTop = this.getSizeHeader();
            console.log('🚀 ~ scroll top', toTop)
            window.scrollTo(0, toTop);
        }
    }

    onListenerScroll = () => {
        if (document.querySelector('#web')) {
            window.addEventListener('scroll', () => {
                const heightHeader = this.getSizeHeader();
                const scrollPosition = (window.scrollY > heightHeader ? window.scrollY - heightHeader : 0);
                document.querySelector('#web').contentWindow.postMessage('scrollPosition:' + scrollPosition, this.getUrlGmm());
            });
        }
    }

    onListenerMessage = () => {
        const iFrame = document.querySelector('#web');

        window.addEventListener('message', (event) => {
            if (event.origin === this.getUrlGmm()) {
                if (String(event.data).startsWith('updateHeightIframe')) {
                    console.log( '🚀 ~ window.message', 'actualizar altura')
                    const height = String(event.data).split(':')[1];
                    iFrame.style.height = height;
                }

                if (String(event.data).startsWith('toTopScroll') || String(event.data).startsWith('toBottomScroll') || String(event.data).startsWith('toMiddleScroll')) {
                    this.onToScroll(event.data);
                   }
            }  
        }, false);
    }

    onLoadIframe = () => {
        const iFrame = document.querySelector('#web');

        if (iFrame) {
            iFrame.setAttribute('scrolling', 'no');
            iFrame.style.height = '400px';

            if (this.props.versionPortal === 'portalPiloto') {
            	this.onListenerScroll();
                this.onListenerMessage();
            }
        }

        if(this.props.versionPortal==="portalProd") {
            this.resizeIframe();
        }
    }

    onResize = debounce(() => {
        if (this.iframeResizer.length && this.iframeResizer[0].iFrameResizer) {
            this.iframeResizer[0].iFrameResizer.resize();
        }
    }, 100);

    getURLPortalAseguradoGMM = (tabActiva) => {
        const jwt = localStorage.getItem("refreshToken");
        const mapTabRutaGMM = {
            "altaSeguimiento" : `acceso/portal/${jwt}/polizas`
            ,"historialCartas" : `acceso/portal/${jwt}/seguimiento`
            ,"ingresoHospitalario": `acceso/portal/${jwt}/ingreso-hospitalario`
        }

        if (servicios.siniestrosReembolsos.portalAseguradoGMM
            && this.props.versionPortal==="portalPiloto")
        {
            const rutaEncontrada =
                mapTabRutaGMM[tabActiva] ?
                mapTabRutaGMM[tabActiva] : mapTabRutaGMM.altaSeguimiento;
            return servicios.siniestrosReembolsos.portalAseguradoGMM
                    + rutaEncontrada;
        } else {
            return servicios.siniestrosReembolsos.portalSiniestros;
        }
    }

    render() {
        const propsComunes = {
            ref: "iFrame",
            frameBorder:"0",
            width:"100%",
            value: "web",
            id: "web",
            className: "frame-reembolsos frame-reembolsos-height",
            "data-origen": this.props.tabActiva,
            "data-height": window.innerHeight,
            allow: "geolocation 'src'",
            src: this.getURLPortalAseguradoGMM(this.props.tabActiva)
        };
        return (
            <div>
                <ReactResizeDetector handleWidth onResize={this.onResize}/>
                {   this.props.tabActiva === "altaSeguimiento" &&
                    <iframe
                        {...propsComunes}
                        onLoad={this.onLoadIframe}
                        name={`${this.props.tid}#altaSeguimiento`}
                    />
                }
                {   this.props.tabActiva === "historialCartas" &&
                    <iframe
                        {...propsComunes}
                        onLoad={this.onLoadIframe}
                        name={`${this.props.tid}#historialCartas`}
                    />
                }
                {   this.props.tabActiva === "ingresoHospitalario" &&
                    <iframe
                        {...propsComunes}
                        onLoad={this.onLoadIframe}
                        name={`${this.props.tid}#ingresoHospitalario#${this.props.valoresHospital}`}
                    />
                }
            </div>
        );
    }
}

AltaReembolsos.propTypes = {
    loading: PropTypes.bool,
    paso: PropTypes.number,
    nombre: PropTypes.string,
    lastlogin: PropTypes.string,
    cliente: PropTypes.string,
    ntfBullet: PropTypes.number,
    dispositivo: PropTypes.string,
    tid: PropTypes.string,
    tabActiva: PropTypes.string
}

const mapState = state => {
    return {
        loading: state.global.loading,
        paso: state.olvide.paso,
        nombre: state.global.nombre,
        lastlogin: state.global.lastlogin,
        cliente: state.global.clienteUnico,
        ntfBullet: state.notificaciones.bullet,
        dispositivo: state.global.dispositivo,
        tid: state.global.tid
    };
};

export default connect(mapState)(AltaReembolsos);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/altaReembolsos.cmpt.js